import BoxVue from './App.vue'
let defaults = {
  activityId: '', // 活动id
  countryId: '', // 学生所在区ID
  studentId: '',
  studentName: ''
}
export default function(Vue) {
  const BoxConstructor = Vue.extend(BoxVue)

  function create(props, resolve) {
    const box = new BoxConstructor({
      el: document.createElement('div'),
      propsData: props
    })
    box.callback = resolve
    return box
  }

  function Box(options) {
    return new Promise(resolve => {
      const _props = setdefaults(options)
      const box = create(_props, resolve)
      document.body.appendChild(box.$el)
    })
  }

  function setdefaults(options) {
    let obj = {}
    const op = Object.assign({}, defaults, options)
    for (let key in op) {
      obj[key] = op[key]
    }

    return obj
  }

  Vue.prototype.$holidayWorkCharge = Box
}



// WEBPACK FOOTER //
// ./src/UIO/holidayWorkCharge/main.js